import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubstitutionPlanForm } from '../forms/SubstitutionPlanForm';

type SubstitutionPlanModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SubstitutionPlanModal = ({ isOpen, onClose }: SubstitutionPlanModalProps) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  return (
    <Modal
      loading={isLoading}
      title={t('substitutions.settings.editSubstitutionPlan')}
      isOpen={isOpen}
      onRequestClose={() => onClose()}
    >
      <SubstitutionPlanForm onLoad={setIsLoading} onClose={onClose} />
    </Modal>
  );
};
